// extracted by mini-css-extract-plugin
module.exports = {"block":"feedback_block__xQqW4","contact":"feedback_contact__1e8F_","groupButtons":"feedback_groupButtons__rIFFj","agreement":"feedback_agreement__3_V5n"};